"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getToggleStyleConfig = exports.labelStyle = exports.defaultGlobalStyle = exports.iconStyle = void 0;
var react_1 = require("@emotion/react");
var colors_1 = require("../../../style/colors");
var design_system_colors_1 = require("../../../style/theme/design-system-colors");
var variables_1 = require("../../../style/variables");
var Blue = colors_1.SixsenseColor.Blue, Gray = colors_1.SixsenseColor.Gray, White = colors_1.SixsenseColor.White;
var DSBlue = design_system_colors_1.DesignSystemColor.Blue;
var DSGray = design_system_colors_1.DesignSystemThemeColor.Gray, Primary = design_system_colors_1.DesignSystemThemeColor.Primary;
exports.iconStyle = react_1.css({
    color: colors_1.SixsenseColor.White.DEFAULT,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 600,
    fontSize: 12,
    paddingTop: '20%',
});
var defaultGlobalStyle = function (checked, size, disabled) { return react_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  pointer-events: ", ";\n  opacity: 1 !important;\n  &:hover .react-switch-bg {\n    background-color: var(", ") !important;\n  }\n  &:focus-within .react-switch-bg {\n    box-shadow: 0px 0px 0px 4px ", ";\n    background-color: ", " !important;\n  }\n  & .react-switch-handle {\n    width: ", " !important;\n    height: ", " !important;\n    top: 2px !important;\n    transform: ", ";\n    box-shadow: var(", ") !important;\n"], ["\n  pointer-events: ", ";\n  opacity: 1 !important;\n  &:hover .react-switch-bg {\n    background-color: var(",
    ") !important;\n  }\n  &:focus-within .react-switch-bg {\n    box-shadow: 0px 0px 0px 4px ", ";\n    background-color: ", " !important;\n  }\n  & .react-switch-handle {\n    width: ", " !important;\n    height: ", " !important;\n    top: 2px !important;\n    transform: ", ";\n    box-shadow: var(", ") !important;\n"])), disabled ? 'none' : 'all', checked ? variables_1.ThemeColor.Primary.DARK_1 : variables_1.RootColor.Gray.LIGHT_2, DSBlue.LIGHT_4, checked ? variables_1.ThemeColor.Primary.DARK_1 : variables_1.RootColor.Gray.LIGHT_3, size === 'small' ? '16px' : '20px', size === 'small' ? '16px' : '20px', checked && size === 'small' ? 'translateX(18px) !important' : undefined, variables_1.Shadow.sm); };
exports.defaultGlobalStyle = defaultGlobalStyle;
var labelStyle = function (size) { return react_1.css({
    gap: size === 'default' ? 12 : 8,
}); };
exports.labelStyle = labelStyle;
var getToggleStyleConfig = function (isTheme6DS, size) {
    return isTheme6DS
        ? __assign({}, getDesignSystemToggleProps(size).base.container) : __assign({}, getDefaultToggleProps(size).base.container);
};
exports.getToggleStyleConfig = getToggleStyleConfig;
var getDefaultToggleProps = function (size) { return ({
    base: {
        container: {
            default: {
                height: size === 'small' ? 16 : 22,
                offColor: Gray.LIGHT_2,
                onColor: Blue.DEFAULT,
                width: size === 'small' ? 28 : 42,
            },
            disabled: {
                offColor: Gray.LIGHT_4,
                onColor: Blue.LIGHT_4,
            },
        },
    },
}); };
var getDesignSystemToggleProps = function (size) { return ({
    base: {
        container: {
            default: {
                borderRadius: 12,
                handleDiameter: size === 'small' ? 16 : 20,
                height: size === 'small' ? 20 : 24,
                offColor: DSGray.LIGHT_3,
                offHandleColor: White.DEFAULT,
                onColor: Primary.DEFAULT,
                onHandleColor: White.DEFAULT,
                width: size === 'small' ? 36 : 44,
            },
            disabled: {
                offHandleColor: DSGray.LIGHT_6,
                offColor: DSGray.LIGHT_4,
                onColor: Primary.LIGHT_4,
                onHandleColor: Primary.LIGHT_6,
            },
        },
    },
}); };
var templateObject_1;
